export default __webpack_public_path__ + "static/media/main_interior_mobile.8079b1f5.gif";